import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import Hero from './components/Hero';
import About from './components/About';
import Features from './components/Features';
import Services from './components/Services';
import SectorsSection from './components/SectorsSection';
import NewsSection from './components/NewsSection';
import Testimonials from './components/Testimonials';
import CTABanner from './components/CTABanner';
import Footer from './components/Footer';
import AboutUsPage from './components/AboutUsPage';
import ServicesPage from './pages/Services/ServicesPage';
import ContactPage from './pages/Contact/ContactPage';
import PublicationsPage from './pages/Publications/PublicationsPage';
import PublicationDetailsPage from './pages/Publications/PublicationDetailsPage';
import NewsPage from './pages/News/NewsPage';
import NewsDetailsPage from './pages/News/NewsDetailsPage';
import LoginPage from './pages/Dashboard/LoginPage';
import DashboardLayout from './pages/Dashboard/DashboardLayout';
import DashboardHome from './pages/Dashboard/DashboardHome';
import NavigationSettings from './pages/Dashboard/NavigationSettings';
import HeroSettings from './pages/Dashboard/HeroSettings';
import AboutSettings from './pages/Dashboard/AboutSettings';
import FeaturesSettings from './pages/Dashboard/FeaturesSettings';
import SectorsSettings from './pages/Dashboard/SectorsSettings';
import ServicesSettings from './pages/Dashboard/ServicesSettings';
import NewsSettings from './pages/Dashboard/NewsSettings';
import TestimonialsSettings from './pages/Dashboard/TestimonialsSettings';
import CTABannerSettings from './pages/Dashboard/CTABannerSettings';
import FooterSettings from './pages/Dashboard/FooterSettings';
import ContactSettings from './pages/Dashboard/ContactSettings';
import ServicesPageSettings from './pages/Dashboard/ServicesPageSettings';
import AboutUsPageSettings from './pages/Dashboard/AboutUsPageSettings';
import PublicationsSettings from './pages/Dashboard/PublicationsSettings';
import BrandingSettings from './pages/Dashboard/BrandingSettings';
import ScrollToTop from './components/ScrollToTop';
import logoImage from './Assets/Image/logo.webp';
import Navbar from './components/Navbar';
import HomePage from './pages/Home/HomePage';

function App() {
  const location = useLocation();
  const isDashboardRoute = location.pathname.startsWith('/dashboard');

  return (
    <div className="landing-page">
      <ScrollToTop />

      {!isDashboardRoute && <Navbar />}

      <Routes>
        <Route path="/" element={<HomePage />} />

        <Route
          path="/services"
          element={<ServicesPage />}
        />

        <Route
          path="/about"
          element={<AboutUsPage />}
        />

        <Route
          path="/contact"
          element={<ContactPage />}
        />

        <Route
          path="/publications"
          element={<PublicationsPage />}
        />
        <Route
          path="/publications/:id"
          element={<PublicationDetailsPage />}
        />

        <Route
          path="/news"
          element={<NewsPage />}
        />
        <Route
          path="/news/:id"
          element={<NewsDetailsPage />}
        />

        {/* Dashboard auth and shell */}
        <Route path="/dashboard/login" element={<LoginPage />} />
        <Route path="/dashboard" element={<DashboardLayout />}>
          <Route index element={<DashboardHome />} />
          <Route path="news" element={<NewsSettings />} />
          <Route path="publications" element={<PublicationsSettings />} />
          <Route path="navigation" element={<NavigationSettings />} />
          <Route path="hero" element={<HeroSettings />} />
          <Route path="about-section" element={<AboutSettings />} />
          <Route path="about-us-page" element={<AboutUsPageSettings />} />
          <Route path="features" element={<FeaturesSettings />} />
          <Route path="sectors" element={<SectorsSettings />} />
          <Route path="services" element={<ServicesSettings />} />
          <Route path="testimonials" element={<TestimonialsSettings />} />
          <Route path="cta-banner" element={<CTABannerSettings />} />
          <Route path="footer" element={<FooterSettings />} />
          <Route path="contact" element={<ContactSettings />} />
          <Route path="contact-page" element={<ContactSettings />} />

          <Route path="services-page" element={<ServicesPageSettings />} />
          <Route path="branding" element={<BrandingSettings />} />
          {/* Future nested routes:
              /dashboard/news, /dashboard/publications, etc. */}
        </Route>
      </Routes>

      {!isDashboardRoute && <Footer />}
    </div>
  );
}

export default App;
